// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__1DDwY","load8":"Spinner__load8__Yvr9N"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 144
// module chunks = 3